import { action } from '@reatom/framework'
import i18next from 'i18next'

import { Result } from '@blade/std-lib'
import { showSnackbarAction } from '@root/shared/ui-kit'

import { changeInviterRequestAction } from './reatom-change-inviter-request-action'

import type { InviteCode } from '@root/entities/referral'

export const changeInviterAction = action(
  async (ctx, args: { inviteCode: InviteCode }) => {
    const result = await ctx.schedule(() =>
      changeInviterRequestAction(ctx, {
        inviteCode: args.inviteCode,
      }),
    )

    Result.match(result, {
      onFailure: () =>
        showSnackbarAction(ctx, {
          intent: 'error',
          text: i18next.t('common.something_went_wrong_try_again'),
        }),
      onSuccess: () => {
        showSnackbarAction(ctx, {
          intent: 'success',
          text: i18next.t('referral.referral_code_has_been_successfully_set'),
        })
      },
    })

    return result
  },
  'changeInviterAction',
)
